import Vue from 'vue'
import Vuex from 'vuex'
import uuid from 'uuid/v4'
import mutations from './mutations'
import actions from './actions'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)
Vue.use(Vuex)
window.swal = require('sweetalert2')

export default new Vuex.Store({
  state: {
    billingRfc: null,
    billingEmail: null,
    billingCFDI: null,
    billingOrder: true,
    billingCFDIUseCase: null,
    billingExistingCFDI: false,
    billingStep: null,
    categories:[],
    category:true,
    component:true,
    currentCustomer: null,
    currentCustomerAddresses:null,
    hoverIndex:-1,
    homeProducts:[],
    showCart:false,
    loginFromCart:false,
    order: { id: uuid(), },
    orderTotals: {},
    restriction:true,
    narrowMenu:false,
    userOrders:null,
    userFavorites:null,
    SubCategoryIndex:-1,
    ShowSubCategory:true,
    showInfoFooter:true,
    marketingStrategies:[],
    shippingProducts:[],
    productEntries:[],
    tokenType:"customer",
    appId:"007669ce-2fce-42c6-ad97-dd160ba0e66b",
    appVersion:"3.0.1",
    /*Stepper Variables*/
    checkoutSteps:[
      'LoginStep',
      'ShippingAddressStep',
      'OrderConfirmationStep',
      'ShippingProfileStep',
      'PaymentStep',
      'OrderVerificationStep'
    ],
    /*Privacy*/
    privacy:{
      purpose:false,
      use:false,
      share:false,
      access:false,
      revoke:false,
      limit:false,
      tracking:false,
      changes:false
    },
     /*Filters*/
     filterProducts:null,
     filterCategories:null,
     filterComponents:null,
    /*Product Detail*/
    currentProductDetail:null,
    /*Questions*/
    questions:{
      gofarma:false,
      location:false,
      hour:false,
      shipping:false,
      order:false,
      service:false,
      cost:false
    },
    /*Profile*/
    prof: 1,
    /*Checkout*/
    checkoutStep:2,
    ranges:[],
    coupons:[],
    paymentMethodEntries:[],
    couponEntries:{},
    shippingProfile:{},
    /*Slider images*/
    sliderImages:[{name:'BanerMap.jpg'},{name:'CarritoDeCompra.png'}],
    instructionImages:['ComoFunciona.png','Contactanos.png','Ordena.png','Recibe.png'],
    /* order */
    paymentMethod:null,
    discountCoupon:null,
    /*Maps*/
    cords:{lat:25.73460690,lng: -100.27017360},
    markers:[{position:{lat:25.73460690,lng: -100.27017360}}],
    /*Toast*/
    closeToast:true,
    /*Filter*/
    categorySlug:null,
    filterParams:null,
    showFilterMenu:false,
    filterIndex:-1,
    /*Order summary*/
    orderSummary:[]
  },
  getters:{},
  mutations,
  actions
})
